import React from "react";
import { Box, chakra } from "@chakra-ui/react";
import { FiCheck } from "react-icons/fi";
import { useUser } from "@utils";

export const ICON_SIZE = "xl";

type LessonProgressProps = {
  tasks: readonly string[];
};

export function LessonProgress({ tasks }: LessonProgressProps) {
  const { user } = useUser();

  const completedTasks =
    user?.tasks?.filter((task) => task.completedAt).map((task) => task.id) ??
    [];

  const percentComplete =
    tasks.filter((task) => completedTasks.includes(task)).length / tasks.length;

  if (!percentComplete) {
    return null;
  }

  return percentComplete === 1 ? (
    <Box fontSize={ICON_SIZE} as={FiCheck} color="success" />
  ) : (
    <chakra.span fontSize="md" fontWeight="normal">
      {Math.round(percentComplete * 100)}%
    </chakra.span>
  );
}
